import WhiteboardMd from '../WhiteboardMd';
import withIntersectionObserver from '../../hoc/index.jsx';

export default withIntersectionObserver(WhiteboardMd);
